// extracted by mini-css-extract-plugin
export default {"root":"RefundPolicy-module__root___38T0V","title":"RefundPolicy-module__title___2DGy8","messageWrapper":"RefundPolicy-module__messageWrapper___1Lgt5"};